import {
  GET_SECTOR_PURCHASING_MECHANISMS,
  GET_SECTOR_PURCHASING_MECHANISMS_ERROR,
  GET_SECTOR_PURCHASING_MECHANISMS_SUCCESS
} from './SectorPurchasingMechanismsSection.actions'

const sectorPurchasingMechanismsSectionState = {
  categories: [],
  csv: [],
  data: [],
  error: null,
  loading: false
}

/**
 * The sector purchasing mechanisms section's reducer.
 */
const sectorPurchasingMechanismsSectionReducer = (
  state = sectorPurchasingMechanismsSectionState,
  { payload, type }
) => {
  switch (type) {
    case GET_SECTOR_PURCHASING_MECHANISMS: {
      return { ...state, loading: true }
    }
    case GET_SECTOR_PURCHASING_MECHANISMS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_SECTOR_PURCHASING_MECHANISMS_SUCCESS: {
      return { ...state, categories: payload.categories, csv: payload.csv, data: payload.data, loading: false }
    }
    default: {
      return state
    }
  }
}

export default sectorPurchasingMechanismsSectionReducer
